import * as i0 from "@angular/core";
export class AppInfoService {
    get title() {
        return 'Management / Board Portal';
    }
}
AppInfoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppInfoService_Factory() { return new AppInfoService(); }, token: AppInfoService, providedIn: "root" });
